/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Microsoft_Calendar_List_SuccessInputs */

const es_tools_microsoft_calendar_list_success = /** @type {(inputs: Tools_Microsoft_Calendar_List_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendarios de Microsoft listados`)
};

const en_tools_microsoft_calendar_list_success = /** @type {(inputs: Tools_Microsoft_Calendar_List_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft calendars listed`)
};

/**
* | output |
* | --- |
* | "Microsoft calendars listed" |
*
* @param {Tools_Microsoft_Calendar_List_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_microsoft_calendar_list_success = /** @type {((inputs?: Tools_Microsoft_Calendar_List_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Microsoft_Calendar_List_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_microsoft_calendar_list_success(inputs)
	return en_tools_microsoft_calendar_list_success(inputs)
});
export { tools_microsoft_calendar_list_success as "tools.microsoft_calendar.list_success" }